import React from 'react';

/**
 * Tipos de documento suportados pelo agent-intake-document.
 * Valor vazio = auto-detectar (a EF classifica via Claude).
 */
export const DOCUMENT_TYPES = [
  { value: '', label: 'Auto-detectar' },
  { value: 'matricula_imovel', label: 'Matrícula de Imóvel' },
  { value: 'contrato_social', label: 'Contrato Social / JUCESP' },
  { value: 'proposta_comercial', label: 'Proposta Comercial' },
  { value: 'ficha_cadastral', label: 'Ficha Cadastral (PF)' },
  { value: 'procuracao', label: 'Procuração' },
  { value: 'ata_reuniao', label: 'Ata de Reunião' },
  { value: 'laudo_avaliacao', label: 'Laudo / Avaliação' },
];

/**
 * Select simples controlado. Uso:
 *   const [type, setType] = useState('');
 *   <DocumentTypeSelector value={type} onChange={setType} />
 */
export default function DocumentTypeSelector({
  value,
  onChange,
  disabled = false,
  className = '',
  label,
}) {
  return (
    <div className={className}>
      {label && (
        <label className="text-[10px] uppercase tracking-wide text-slate-500 font-semibold block mb-0.5">
          {label}
        </label>
      )}
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="px-2 py-1.5 border border-slate-200 rounded text-xs bg-white focus:outline-none focus:border-blue-400 disabled:opacity-50"
      >
        {DOCUMENT_TYPES.map((t) => (
          <option key={t.value} value={t.value}>{t.label}</option>
        ))}
      </select>
    </div>
  );
}
